import { fetch } from '@nackle/studio-tools';
import { cmxURL } from 'endpoints';
import CmxSDK from '@nackle/cmx-sdk';

const DEFAULT_LOCALE = 'en-US';

export default function CmxService() {
    const sdk = new CmxSDK( cmxURL, fetch );

    const getBundle = async ( bundleName, locale = DEFAULT_LOCALE ) => {
        const response = await sdk.getBundle( bundleName, locale );
        return response.bundles[ locale ];
    };

    const getMergedBundle = async ( bundleNames, locale ) => {

        const bundleData = await Promise.all( bundleNames.map(
            bundleName => getBundle( bundleName, locale )
        ) );

        let mergedBundle = bundleData[ 0 ];
        for ( let i = 1; i < bundleData.length; i++ ) {
            mergedBundle = {
                ...mergedBundle,
                ...bundleData[ i ]
            };
        }
        return mergedBundle;
    };

    return {
        getBundle,
        getMergedBundle
    };
}